import * as yup from 'yup';

import { WebhookType } from '@/shared/types/webhook';

import { LENGTH_S, LENGTH_XL, LENGTH_XXL } from '../constants';

export const webhookSchema = yup
  .object()
  .shape({
    name: yup.string().max(LENGTH_S).required().defined(),
    url: yup.string().url().max(LENGTH_XXL).required().defined(),
    token: yup.string().max(LENGTH_XL).required().defined(),
    type: yup.string().oneOf(Object.values(WebhookType)).required().defined(),
  })
  .required();
